import { render, staticRenderFns } from "./CourierRegistration.vue?vue&type=template&id=ee02e324"
import script from "./CourierRegistration.vue?vue&type=script&lang=js"
export * from "./CourierRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports